import { render, staticRenderFns } from "./VozBannerSection.vue?vue&type=template&id=53e98946"
import script from "./VozBannerSection.vue?vue&type=script&lang=ts"
export * from "./VozBannerSection.vue?vue&type=script&lang=ts"
import style0 from "./VozBannerSection.vue?vue&type=style&index=0&id=53e98946&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports